import React from 'react';

const ViewIconWhite = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.12198 6.84543C6.11303 4.69338 7.84797 2.94028 10 2.92683C11.0392 2.92034 12.0381 3.32862 12.7752 4.06117C13.5124 4.79373 13.9268 5.79004 13.9268 6.82927C13.9268 8.98135 12.1845 10.7272 10.0325 10.7316C7.8804 10.7361 6.13094 8.99749 6.12198 6.84543ZM7.58542 6.81318C7.57648 8.15699 8.65622 9.25486 10 9.2683C10.6511 9.27481 11.2777 9.02072 11.7404 8.5626C12.2031 8.10449 12.4634 7.48039 12.4634 6.82927C12.4633 5.48543 11.3763 4.39482 10.0324 4.39038C8.6886 4.38595 7.59435 5.46936 7.58542 6.81318Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7318 6.56105L19.8293 6.82934L19.7318 7.09763C18.3659 10.6098 13.9513 13.561 10.0244 13.5854H9.97565C6.04883 13.561 1.63419 10.6098 0.268337 7.09763L0.170776 6.82934L0.268337 6.56105C1.63419 3.04885 6.04883 0.0976324 9.97565 0.0732422H10.0244C13.9513 0.0976324 18.3659 3.04885 19.7318 6.56105ZM1.75614 6.82934C3.00004 9.63422 6.82931 12.122 10 12.122C13.1708 12.122 17 9.63422 18.2439 6.82934C17 4.02446 13.1708 1.53666 10 1.53666C6.82931 1.53666 3.00004 4.02446 1.75614 6.82934Z"
      fill="#fff"
    />
  </svg>
);

export default ViewIconWhite;
